import thankYou from '@assets/images/thank-you.webp';



interface ThankYouProps {
	registration?: boolean,
}


const ThankYou = (props: ThankYouProps): JSX.Element => {
	const { registration = false } = props;

	return (
		<div className="app-page thank-you-page">
			
			{registration
				? <h1>Děkujeme za&nbsp;Vaši registraci</h1>
				: <h1>Děkujeme za&nbsp;Vaši objednávku</h1>}

			<div className='thank-text'>
				<p>{registration ? 'Registrace' : 'Objednávka'} byla odeslána.</p>
				<p>Její potvrzení přijde na&nbsp;Vaši e-mailovou adresu. Pokud potvrzovací e-mail neobdržíte do&nbsp;několika minut, kontaktujte&nbsp;nás nebo {registration ? 'udělejte novou registraci' : 'zadejte novou objednávku'}.</p>
			</div>
			
			<div className='thank-image'>
				<img src={thankYou} alt='thank-you-photo' />	
			</div>

		</div>
	);
};

export default ThankYou;